// leadPriorityColor — tiny module that maps a priority bucket
// (from /api/leads/morning-brief's priority_by_lead_id) to a Tailwind
// background + border + accent bar tone. Used by row / card renders
// so every lead surface uses the SAME color language.
//
// This is the "AI Heat Map" from the spec — one glance tells the
// operator which leads matter most.

export const PRIORITY_LABEL = {
  call_now:  { label: 'Call now',     emoji: '🔥', text: 'Call immediately' },
  call_today:{ label: 'Call today',   emoji: '⏰', text: 'Call today'       },
  follow_up: { label: 'Follow up',    emoji: '📨', text: 'Text or email'    },
  nurturing: { label: 'AI nurturing', emoji: '🤖', text: 'AI handling'      },
  at_risk:   { label: 'At risk',      emoji: '⚠️', text: 'Long silence'     },
  won:       { label: 'Won',          emoji: '✅', text: 'Closed'           },
  dead:      { label: 'Dead',         emoji: '🚫', text: 'Do not contact'   },
};

// Inline styles for the row / card. Tailwind classes vary by mode
// (list vs card vs dashboard) so we return a color palette instead.
export function priorityPalette(bucket) {
  switch (bucket) {
    case 'call_now':  return { bg: '#fef2f2', border: '#fca5a5', accent: '#dc2626', accentText: '#991b1b' };
    case 'call_today':return { bg: '#fff7ed', border: '#fed7aa', accent: '#f97316', accentText: '#9a3412' };
    case 'follow_up': return { bg: '#fefce8', border: '#fde047', accent: '#eab308', accentText: '#854d0e' };
    case 'nurturing': return { bg: '#f0fdf4', border: '#bbf7d0', accent: '#22c55e', accentText: '#166534' };
    case 'at_risk':   return { bg: '#faf5ff', border: '#e9d5ff', accent: '#a855f7', accentText: '#6b21a8' };
    case 'won':       return { bg: '#ecfdf5', border: '#a7f3d0', accent: '#059669', accentText: '#065f46' };
    case 'dead':      return { bg: '#f1f5f9', border: '#cbd5e1', accent: '#64748b', accentText: '#334155' };
    default:          return { bg: '#ffffff', border: '#e2e8f0', accent: '#94a3b8', accentText: '#475569' };
  }
}

// Tailwind class variant for use inside class strings. Same
// vocabulary; consumers pick whichever pairs with their existing
// styling. Returns a compact string, not the full palette.
export function priorityClass(bucket) {
  switch (bucket) {
    case 'call_now':  return 'bg-red-50 border-l-4 border-red-500';
    case 'call_today':return 'bg-orange-50 border-l-4 border-orange-500';
    case 'follow_up': return 'bg-yellow-50 border-l-4 border-yellow-500';
    case 'nurturing': return 'bg-green-50 border-l-4 border-green-400';
    case 'at_risk':   return 'bg-purple-50 border-l-4 border-purple-500';
    case 'won':       return 'bg-emerald-50 border-l-4 border-emerald-500';
    case 'dead':      return 'bg-slate-50 border-l-4 border-slate-400 opacity-60';
    default:          return 'bg-white border-l-4 border-transparent';
  }
}
